import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LoggedOutLayoutComponent } from './roles/logged-out-layout/logged-out-layout.component';
import { NoRoleLayoutComponent } from './roles/no-role-layout/no-role-layout.component';
import { RouterModule } from '@angular/router';
import { StaffLayoutComponent } from './roles/staff-layout/staff-layout.component';
import {
  TuiDataListModule,
  TuiFlagPipeModule,
  TuiHostedDropdownModule,
  TuiSvgModule,
} from '@taiga-ui/core';
import { MainNavbarComponent } from './headers/main-navbar/main-navbar.component';
import { TuiOverscrollModule } from '@taiga-ui/cdk';
import { UserMenuComponent } from './partials/user-menu/user-menu.component';
import { TuiAvatarModule } from '@taiga-ui/kit';
import { ViewMenuComponent } from './partials/view-menu/view-menu.component';
import { QuickAddMenuComponent } from './partials/quick-add-menu/quick-add-menu.component';
import { PipesModule } from '../pipes/pipes.module';
import { LangSwitchComponent } from './partials/lang-switch/lang-switch.component';

@NgModule({
  declarations: [
    LoggedOutLayoutComponent,
    NoRoleLayoutComponent,
    StaffLayoutComponent,
    MainNavbarComponent,
    UserMenuComponent,
    ViewMenuComponent,
    QuickAddMenuComponent,
    LangSwitchComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TuiFlagPipeModule,
    NgOptimizedImage,
    TuiOverscrollModule,
    TuiAvatarModule,
    TuiDataListModule,
    TuiHostedDropdownModule,
    TuiSvgModule,
    PipesModule,
  ],
  exports: [
    LoggedOutLayoutComponent,
    NoRoleLayoutComponent,
    StaffLayoutComponent,
  ],
})
export class LayoutsModule {}
